export const cameraDownscaleSize = 256
export const lightProcessingSize = 32
